// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flicking-viewport[data-v-6309b725]{transition:height .5s}.flicking-camera[data-v-6309b725]{display:flex;align-items:center}.flicking-panel[data-v-6309b725]{transition:transform .5s,opacity .5s;transform-origin:center center}.flicking-panel.is-active[data-v-6309b725]{transform:rotateY(0deg) scale(1.2);z-index:1}.flicking-panel[data-v-6309b725]:not(.is-active){opacity:.5}", ""]);
// Exports
module.exports = exports;
